import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { Link as RouterLink, useHistory } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Card, Stack, Link, Container, Typography } from '@mui/material';
// layouts
import AuthLayout from 'layouts/AuthLayout';
// components
import LogoPNG from "assets/logo.png";
import Page from 'components/Page';
import { MHidden } from 'components/@material-extend';
import { LoginForm } from 'components/authentication/login';
import { getVersion } from "utils/common";
// services
import { loginAdmin } from "services/auth.service";
import { setLoginReducer, setOrgReducer } from "store/reducer/user.reducer";
// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2)
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function Login() {
  const dispatch = useDispatch();
  const history = useHistory();

  const onSubmit = useCallback(async (values) => {
    const res = await loginAdmin(values);
    if (res && res.status === 200) {
      const { token } = res.data;
      localStorage.setItem("accessToken", token);
      localStorage.setItem("currentUser", JSON.stringify(res.data));
      dispatch(setLoginReducer(res.data));
      dispatch(setOrgReducer(res.data?.organizations?.length > 0 ? res.data?.organizations[0] : ""));
      
      history.push("/admin");
    }
  }, [history]);

  return (
    <RootStyle title="Login">
      <AuthLayout>
        Don’t have an account? &nbsp;
        <Link underline="none" variant="subtitle2" component={RouterLink} to="/register">
          Get started
        </Link>
      </AuthLayout>

      <MHidden width="mdDown">
        <SectionStyle>
          <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}>
            Hi, Welcome Back
          </Typography>
          <img src="/static/illustrations/illustration_login.png" alt="login" />
        </SectionStyle>
      </MHidden>

      <Container maxWidth="sm">
        <ContentStyle>
          <Stack sx={{ mb: 5, alignItems: "center", justifyContent: "center" }}>
            <img alt="logo" src={LogoPNG} style={{width: "85px"}} />
            <span style={{fontSize: "14px", fontWeight: "bold"}}>Version {getVersion()}</span>
          </Stack>
          <LoginForm isAdmin={true} onSubmit={onSubmit} />

          <MHidden width="smUp">
            <Typography variant="body2" align="center" sx={{ mt: 3 }}>
              Don’t have an account?&nbsp;
              <Link variant="subtitle2" component={RouterLink} to="register">
                Get started
              </Link>
            </Typography>
          </MHidden>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
